import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format, formatDistanceToNow } from "date-fns";
import { cn } from "../../utils";
import { getTextColor } from "./colors";
import { InsolvencyMonitorCard } from "./InsolvencyMonitorCard";
import { LiquidatorCard } from "./LiquidatorCard";
import { MultisigWatcherCard } from "./MultisigWatcherCard";
import { OptimistCard } from "./OptimistCard";
import { PriceMonitorCard } from "./PriceMonitorCard";
import { SDKCard } from "./SDKCard";
export const ActiveServiceCard = ({ data }) => {
    const startTime = new Date(data.startTime * 1000);
    const lastUpdate = new Date(data.timestamp.value * 1000);
    const updateColor = getTextColor(data.timestamp.status);
    let content = null;
    switch (data.family) {
        case "multisig-watcher":
            content = (_jsx(MultisigWatcherCard, { data: data }));
            break;
        case "optimists":
            return _jsx(OptimistCard, { data: data });
        case "liquidators":
            content = _jsx(LiquidatorCard, { data: data });
            break;
        case "insolvency-monitors":
            content = (_jsx(InsolvencyMonitorCard, { data: data }));
            break;
        case "price-monitors":
            content = _jsx(PriceMonitorCard, { data: data });
            break;
        default:
            if ("currentBlock" in data) {
                content = _jsx(SDKCard, { data: data });
            }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-row items-center", children: [_jsx("div", { className: "w-34", children: "Version" }), _jsx("div", { children: data.version })] }), _jsxs("div", { className: "flex flex-row items-center", children: [_jsx("div", { className: "w-34", children: "Uptime" }), _jsx("div", { children: formatDistanceToNow(startTime, { addSuffix: false }) })] }), _jsxs("div", { className: "flex flex-row items-start", children: [_jsx("div", { className: cn("w-34 shrink-0", updateColor), children: "Last Update" }), _jsxs("div", { className: "flex items-center flex-wrap gap-x-1", children: [_jsx("span", { children: formatDistanceToNow(lastUpdate, { addSuffix: true }) }), _jsx("span", { className: cn("text-xs text-gray-500", updateColor), children: format(lastUpdate, "MMM dd, yyyy HH:mm:ss") })] })] }), "currentBlock" in data && data.currentBlock !== undefined && (_jsxs("div", { className: "flex flex-row items-center", children: [_jsx("div", { className: "w-34", children: "Last block" }), _jsx("div", { children: data.currentBlock.toString(10) })] })), content] }));
};
